import type { ImageOption } from '@rock/types';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Google Images search for test-library photos. The query is composed here (the caller has the
 * equipment type loaded, and the operator can retype it) — server-side, `requireAdmin` gates it.
 *
 * One SerpAPI credit per call, from a budget the manuals worker already dominates: call it on an
 * explicit click, never on render or on every keystroke.
 */
export async function searchTestLibraryImages(query: string): Promise<ImageOption[]> {
    const fn = httpsCallable<{ query: string }, { options: ImageOption[] }>(getFunctions(), 'searchTestLibraryImages');
    const result = await fn({ query });
    return result.data.options;
}

/** Default search text for each photo slot — shown in the dialog, editable before searching. */
export function defaultImageQuery(slot: 'product' | 'nameplate', typeTitle: string, brand?: string): string {
    const subject = `${brand ?? ''} ${typeTitle}`.trim();
    return slot === 'product' ? subject : `${subject} model number data plate label`;
}
